// Display name for a custom field: the user-set label when present, else the
// raw field name. `name` is machine identity (Meta question sync overwrites it,
// payload keys and country/intake detection match on it) — NEVER use label for
// matching, filtering keys, or import header identity. Display only.
export interface CfDisplayable {
  label?: string | null;
  name?: string | null;
}

export const getCfDisplayName = (f: CfDisplayable | null | undefined): string =>
  f?.label?.trim() || f?.name || "";
